import Vue from "vue";

import "./plugins/bootstrap-vue";
import BootstrapVue from "bootstrap-vue";

import VueScrollTo from "vue-scrollto";
import VueProgressBar from "vue-progressbar";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import money from "v-money";

import { KinesisContainer, KinesisElement } from "vue-kinesis";

import VueTagManager from "vue-tag-manager";

// Do this before creating the Vue app
Vue.use(VueTagManager, {
  gtmId: "GTM-P5F2JSN",
});

// uses x directives
Vue.use(BootstrapVue);
Vue.use(VueScrollTo);
Vue.use(VueProgressBar, {
  color: "#4a1965",
  failedColor: "#874b4b",
  thickness: "6px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
});
Vue.use(money, { precision: 4 });
Vue.component("kinesis-container", KinesisContainer);
Vue.component("kinesis-element", KinesisElement);

// imports.scss
import "./scss/main.scss";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
